module.exports = __webpack_public_path__ + "static/DORIS@2x-1113337da9b84c9007cbc54777f005a9.svg";